(function($) {

	function svgicon(family, icon) {
		var href = '/images/icons.svg#' + family + '-' + icon;
		return $.parseHTML(
			'<svg class="icon" focusable="false"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + href + '"></use></svg>'
		)[0];
	}

	$.datepicker.setDefaults({

		firstDay: 1,
		dateFormat: 'dd/mm/yy',
		duration: 100,

		afterShow: function(input, datepicker) {

			var $datepicker = $(datepicker.dpDiv);
			$datepicker.find('.ui-datepicker-prev').empty().append(svgicon('fa', 'angle-left'));
			$datepicker.find('.ui-datepicker-next').empty().append(svgicon('fa', 'angle-right'));

		},

		onSelect: function(dateText, datepicker) {

			$(this).trigger('datepicker.select', [dateText, datepicker]);

		},

	});

}(jQuery));
